export const ValidationUtil = {

	// Only allows a-z, A-z, 0-9 and hyphen
	isAlphaNumeric(string) {
		return /^([a-zA-Z\-0-9])*$/.test(string);
	},

	isAlphaNumericWithWhiteSpace(string) {
		return /^([a-zA-Z\-0-9\s])*$/.test(string);
	},

	isAlphaNumericWithWhiteSpaceAndComma(string) {
		return /^([a-zA-Z\-0-9\s,])*$/.test(string);
	},

	isAlphaWithWhiteSpace(string) {
		return (/^([a-zA-Z\-.\s])*$/.test(string));
	},

	isAlphaWithWhiteSpaceAndComma(string) {
		return (/^([a-zA-Z\-,\s])*$/.test(string));
	},

	isCharacter(string) {
		return (/^([a-zA-Z])*$/.test(string));
	},

	isNumeric(string) {
		return /^(\d)*$/.test(string);
	},

	// Param: dateStrng with "mm-dd-yyyy" format
	isDate(string) {
		return /^(0[1-9]|1[0-2])-(0[1-9]|1\d|2\d|3[01])-(19|20)\d{2}$/.test(string);
	},

	objectHasField(fieldName, fieldValue, ObjectToCompare) {
		if (ObjectToCompare) {
			let lowerCaseNames = []

			ObjectToCompare.forEach(objectItem => {
				lowerCaseNames.push(objectItem[fieldName].toLowerCase());
			});

			let lowerCaseFieldValue = fieldValue.toLowerCase();
			if (lowerCaseNames.includes(lowerCaseFieldValue)) {
				return true;
			}
		}
		return false;
	},

	arrayHasValue(optionArr, fieldName, valueToCompare) {
		let found = false;
		if (optionArr && optionArr.length > 0) {
			found = optionArr.some(function (el) {
				if (el.value === null) {
					return false;
				}
				return el.value[fieldName] === valueToCompare;
			});
		}
		return found;
	},

	arrayHasValueDirectField(optionArr, fieldName, valueToCompare) {
		let found = false;
		if (optionArr && optionArr.length > 0) {
			found = optionArr.some(function (el) {
				return el[fieldName] === valueToCompare;
			});
		}
		return found;
	},

	// return empty string for null param
	removeExcessWhiteSpace(stringValue) {
		let trimmedStr = '';
		if (stringValue) {
			trimmedStr = stringValue.trim().replace(/\s\s+/g, ' ');
		}
		return trimmedStr;
	},

	arrayContains(array, letters) {
		let status = false;
		letters.forEach(letter => {
			array.forEach(item => {
				if (item.includes(letter)) status = letter;
			});
		});
		return status;
	}
}
